
var scrollBars = () => {
    $('[data-scrollable]').mCustomScrollbar({
        theme: "dark",
        // scrollbarPosition: 'outside',
        scrollInertia: 1000,
        mouseWheel: {
            preventDefault: true
        }
    });
};

export { scrollBars }


// WEBPACK FOOTER //
// ./js/form/scrollbar.js